import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Loader, tabs } from "../../components";

import { UniversityAction } from "../../store/actions";

import ApplicationJourney from "./app-journey";
import Checklists from "./checklists";
import Deadlines from "./deadlines";
import General from "./general";
import Others from "./others";
import Programs from "./programs";
import Restaurants from "./restaurants";
import Scholarships from "./scholarships";
import TestScores from "./test-scores";

import "./styles.css";

const EditUniversity = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const profileData = useSelector((state) => state?.profile?.user);
  const { isLoading } = useSelector((state) => state?.university);

  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    dispatch(UniversityAction.getUniversityDetailsAdmin(id));
  }, [profileData]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const tabsArray = [
    {
      label: <div className="uni-details-tabs-container">General</div>,
      key: "1",
      children: <General />,
    },
    {
      label: <div className="uni-details-tabs-container">Programs</div>,
      key: "2",
      children: <Programs />,
    },
    {
      label: <div className="uni-details-tabs-container">Test Scores</div>,
      key: "3",
      children: <TestScores />,
    },
    {
      label: <div className="uni-details-tabs-container">Scholarships</div>,
      key: "4",
      children: <Scholarships />,
    },
    {
      label: <div className="uni-details-tabs-container">Restaurants</div>,
      key: "5",
      children: <Restaurants />,
    },
    {
      label: (
        <div className="uni-details-tabs-container">Applications Journey</div>
      ),
      key: "6",
      children: <ApplicationJourney />,
    },
    {
      label: <div className="uni-details-tabs-container">Checklists</div>,
      key: "7",
      children: <Checklists />,
    },
    {
      label: <div className="uni-details-tabs-container">Deadlines</div>,
      key: "8",
      children: <Deadlines />,
    },
    {
      label: <div className="uni-details-tabs-container">Others</div>,
      key: "9",
      children: <Others />,
    },
  ];

  return (
    <div className="text-black">
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <>
          <tabs.UniversityTab
            key={activeTab}
            activeKey={activeTab}
            items={tabsArray}
            onChange={handleTabChange}
          />
        </>
      )}
    </div>
  );
};

export default EditUniversity;
